import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChip: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChip"><Path d="M7.5 5.5V3.5M12 5.5V3.5M16.5 5.5V3.5M7.5 20.5V18.5M12 20.5V18.5M16.5 20.5V18.5M3.5 3.5H20.5V20.5H3.5V3.5ZM7.5 8.5H16.5V15.5H7.5V8.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconChip;
